import { AfterViewInit, Component, Input, ViewChild } from '@angular/core';

@Component({
  template: '<div #content></div>',
  selector: 'sc-custom-table-cell-content'
})
export class CustomTableCellContentComponent implements AfterViewInit {

  @Input() public htmlTemplate;
  @ViewChild('content', { static: false }) public content;

  constructor() {

  }

  ngAfterViewInit(): void {
    this.content.nativeElement.insertAdjacentHTML('beforeend', this.htmlTemplate);
  }
}
